// utils/sendRichMessage.js
import socket from './socket';
/**
 * Sends a rich message via socket.
 * @param {string} dob - The date of birth string in dd/mm/yyyy format.
 * @param {object} reduxState - The Redux state object (i.e. state from useSelector or passed down).
 */
export const sendRichMessage = (dob, reduxState) => {
  const { engagement, user } = reduxState;

  const richMedia = {
    selectedAction: {
      type: 'reply',
      payload: dob,
    }
  };

  const body = {
    elementType: 'reply',
    elementText: {
      text: dob,
      textFormat: 'PLAINTEXT'
    },
    payload: dob,
    richMediaPayload: richMedia
  };

  const message = {
    body: body,
    senderName: user.data.displayName,
    providerDialogId: engagement.params.CustomerVerified === "true"
      ? (user.data.chProviderDialogId !== undefined
          ? user.data.chProviderDialogId
          : user.data.providerDialogId)
      : user.data.providerDialogId,
    providerSenderId: engagement.params.CustomerVerified === "true"
      ? (user.data.chProviderSenderId !== undefined
          ? user.data.chProviderSenderId
          : user.data.providerSenderId)
      : user.data.providerSenderId,
    engagementParam: user.data.engagementParameters,
    customerIdentifiers: user.data.customerIdentifiers,
  };

  const s = socket.getInstance();

  s.emit("message", message, (res) => {
    if (res.hasError) {
      console.error("Socket message error:", res);
    }
  });
};
